import type { KlearDate } from '@klear/date'
import type { Money } from '@klear/money'
import type { InvoiceEventFormValues } from '@klear/invoice/wire.client'
import type { OperationalEventFormValues } from '@klear/operational/wire.client'
import type { ProofOfAcceptanceEventFormValues } from '@klear/proof-of-acceptance/wire.client'
import type { PurchaseOrderEventFormValues } from '@klear/purchase-order/wire.client'
import { createInvoiceEventForm, invoiceEventFormFromInvoice } from '@klear/invoice/wire.client'
import type { Invoice } from '@klear/invoice/invoice'
import { createOperationalEventForm, operationalToEventForm } from '@klear/operational/wire.client'
import type { Operational } from '@klear/operational/operational'
import { createProofOfAcceptanceEventForm, proofOfAcceptanceToEventForm } from '@klear/proof-of-acceptance/wire.client'
import type { ProofOfAcceptance } from '@klear/proof-of-acceptance/proof-of-acceptance'
import { createPurchaseOrderEventForm, purchaseOrderToEventForm } from '@klear/purchase-order/wire.client'
import type { PurchaseOrder } from '@klear/purchase-order/purchase-order'

export type EventFormParentDefaults = {
  amount?: Money
  endDate?: KlearDate
  supplierId?: string | number
}

export function purchaseOrderReadToFormSchema(read: PurchaseOrder): PurchaseOrderEventFormValues {
  return purchaseOrderToEventForm(read)
}

export function createPurchaseOrderFormSchema(): PurchaseOrderEventFormValues {
  return createPurchaseOrderEventForm()
}

export function invoiceReadToFormSchema(invoice: Invoice): InvoiceEventFormValues {
  return invoiceEventFormFromInvoice(invoice)
}

export function createInvoiceFormSchema(parent?: EventFormParentDefaults): InvoiceEventFormValues {
  return createInvoiceEventForm(parent)
}

export function operationalReadToFormSchema(read: Operational): OperationalEventFormValues {
  return operationalToEventForm(read)
}

export function createOperationalFormSchema(parent?: EventFormParentDefaults): OperationalEventFormValues {
  return createOperationalEventForm(parent)
}

export function proofOfAcceptanceReadToFormSchema(read: ProofOfAcceptance): ProofOfAcceptanceEventFormValues {
  return proofOfAcceptanceToEventForm(read)
}

export function createProofOfAcceptanceFormSchema(): ProofOfAcceptanceEventFormValues {
  return createProofOfAcceptanceEventForm()
}
